<template>
  <transition-group
    appear
    tag="div"
    class="grid grid-3"
    @before-enter="beforeEnter"
    @enter="enter"
  >
    <div data-index="1" :key="1">
      <i class="map marker alternate icon" />
      <h4>Where to find me</h4>
      <small>{{ contact.address }}</small>
    </div>
    <div data-index="2" :key="2">
      <i class="mail icon" />
      <h4>Email me at</h4>
      <small>
        {{ contact.email1 }} <br />
        {{ contact.email2 }}</small
      >
    </div>
    <div data-index="3" :key="3">
      <i class="phone rotated icon" />
      <h4>Call me at</h4>
      <small>
        {{ contact.phone1 }} <br />
        {{ contact.phone2 }}</small
      >
    </div>
  </transition-group>
</template>
<script>
export default {
  props: { contact: Object, beforeEnter: Function, enter: Function },
};
</script>
